import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Collapse from "react-bootstrap/Collapse";
import reportAction from "../../../store/actions/reportCampaignAction";
import linkTypeCampaigns from "../campaigns/linkTypeCampaigns";
import typeCampaignCategorySelected from "./TypeCampaignCategorySelected";
import SeparationActive from "./SeparationActive";
import ReportData from "./ReportData";

const HeaderReport = ({
  dateFrom,
  dateTo,
  eventDataChart,
  whichSeparationActive,
  setTypeSeparationDataChart,
  getCampaignReportWithCampaignName,
  getCampaignReportPieChart,
  getCampaignReportLineChart,
  getReportAllCampaign,
  getReportAllCampaignPieChart,
  getReportAllCampaignLineChart,
}) => {
  const [open, setOpen] = useState(false);

  const changeNameItemReport = (nameItemReport) => {
    document.querySelector("#name-item-report").textContent = nameItemReport;
  };

  const removeLastBgPrimaryClassTag = () => {
    document
      .querySelector(".drop-down-select-campaign .bg-success")
      .classList.remove("bg-success");
  };

  const addClassBgPrimaryToTag = (e) => {
    e.currentTarget.classList.add("bg-success");
    e.currentTarget.firstChild.classList.add("text-dark");
  };

  const closeDropDownSelectCampaign = () => {
    document
      .querySelector(".dropdown-menu.drop-down-select-campaign")
      .classList.remove("show");
  };

  const clickCampaignNameHandler = (e, campaignID) => {
    changeNameItemReport(e.currentTarget.textContent);
    const parentCollapsedTag = document.querySelector(
      "#" + e.currentTarget.parentNode.parentNode.id
    );
    parentCollapsedTag.classList.add("show");
    removeLastBgPrimaryClassTag();
    addClassBgPrimaryToTag(e);
    closeDropDownSelectCampaign();
    getCampaignReportWithCampaignName({
      campaign_id: campaignID,
      date_from: dateFrom,
      date_to: dateTo,
    });

    let separationNow = whichSeparationActive;
    if (whichSeparationActive == SeparationActive.CAMPAIGN) {
      separationNow = SeparationActive.PUBLISHER;
      setTypeSeparationDataChart({
        separation: separationNow,
      });
    }
    getCampaignReportLineChart({
      campaign_id: campaignID,
      date_from: dateFrom,
      date_to: dateTo,
    });
    getCampaignReportPieChart({
      campaign_id: campaignID,
      date_from: dateFrom,
      date_to: dateTo,
    });
  };

  return (
    <div
      id="name-campaigns"
      className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-1"
    >
      <div className="p-2 d-flex align-items-center justify-content-between">
        <span id="name-item-report" className="text-dark">
          کمپین های شما
        </span>
        <span id="container-dropdown-select-campaign-report">
          <div className="dropdown ">
            <button
              className="btn dropdown-toggle text-dark"
              type="button"
              id="drop-down-button-select-campaign"
              data-toggle="dropdown"
              aria-haspopup="false"
              aria-expanded="false"
            >
              همه کمپین ها
            </button>
            <div
              className="dropdown-menu drop-down-select-campaign py-0 my-0 border-success border-bottom-0"
              style={{ width: "300px" }}
              aria-labelledby="drop-down-button-select-campaign"
            >
              <div className="d-flex flex-column border-radius-drop-down-select-campaign">
                <span
                  className="py-2 pr-2 bg-success border-success border-bottom text-right hover border-radius-top-drop-down-select-campaign "
                  onClick={(e) => {
                    removeLastBgPrimaryClassTag();
                    addClassBgPrimaryToTag(e);
                    changeNameItemReport(e.currentTarget.textContent);
                    getReportAllCampaign({
                      date_from: dateFrom,
                      date_to: dateTo,
                    });
                    getReportAllCampaignPieChart({
                      date_from: dateFrom,
                      date_to: dateTo,
                    });
                    getReportAllCampaignLineChart({
                      date_from: dateFrom,
                      date_to: dateTo,
                    });
                  }}
                >
                  <span className="text-dark text-right"> همه کمپین ها</span>
                </span>

                <div>
                  <div
                    className="card-header pr-2 py-2 m-0 border-success rounded-0"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(!open);
                    }}
                    aria-controls="accordion-body-all-campaign-banner"
                    aria-expanded={open}
                  >
                    <div className="mb-0">
                      <div className=" d-flex hover  justify-content-between ">
                        <span className="text-dark text-right">
                          کمپین های بنری
                        </span>
                        <span>
                          <i
                            id="header-banner-accordion-icon"
                            className={`fa fa-angle-${open ? "down" : "left"}`}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <Collapse in={open}>
                  <div id="accordion-body-all-campaign-banner">
                    <div className="card-body p-0 ">
                      {ReportData.map((campaign) => {
                        return (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              clickCampaignNameHandler(e, campaign.id);
                            }}
                            className="py-2 pr-2 hover text-right border-success border-bottom"
                          >
                            <span>{campaign.name}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    whichTypeSelect: state.reportCampaign.which_type_select,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    eventDataChart: state.reportCampaign.event_data_chart,
    whichSeparationActive: state.reportCampaign.which_separation_active,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignReportWithCampaignName: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignReportPieChart: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_PIE_CHART,
        payload: action,
      });
    },
    getCampaignReportLineChart: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_LINE_CHART,
        payload: action,
      });
    },
    getReportAllCampaign: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_CAMPAIGN,
        payload: action,
      });
    },
    getReportAllCampaignPieChart: (action) => {
      dispatch({
        type: reportAction.GET_ALL_CAMPAIGN_REPORT_PIE_CHART,
        payload: action,
      });
    },
    getReportAllCampaignLineChart: (action) => {
      dispatch({
        type: reportAction.GET_ALL_CAMPAIGN_REPORT_LINE_CHART,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderReport);
